// @flow
import * as React from 'react'
import Cleave from 'cleave.js/dist/cleave-react'
import { FormErrorAlert, FormSuccessAlert } from 'ui/Form'

import './TextInput.scss'

type TextInputType = 'text' | 'search' | 'password' | 'email' | 'tel'

export type Props = {
  name: string,
  appearance?: 'white',
  type: TextInputType,
  className: string,
  placeholder: string,
  value: ?string,
  disabled: boolean,
  spellCheck: boolean,
  autoFocus: boolean,
  id?: string,
  error?: string,
  success?: string,
  format?: any,
  maxLength?: number,
  onFocus: () => void,
  onBlur: () => void,
  onChange: string => void,
  appendAddOn?: React.Node,
}

export default class TextInput extends React.Component<Props> {
  static defaultProps = {
    type: 'text',
    className: 'TextInput',
    placeholder: '',
    value: '',
    disabled: false,
    spellCheck: true,
    autoFocus: false,
    onFocus: () => undefined,
    onBlur: () => undefined,
  }

  render = () => {
    return (
      <div className={`${this.props.className} ${this.classNameModifier}`}>
        {this.props.appendAddOn ? this.renderAddOnGroup() : this.renderControl()}
        {this.renderErrorMaybe()}
        {this.renderSuccessMaybe()}
      </div>
    )
  }

  renderAddOnGroup = () => {
    return (
      <div className={`${this.props.className}-addOnGroup`}>
        {this.renderControl()}
        <div className={`${this.props.className}-appendAddOn`}>{this.props.appendAddOn}</div>
      </div>
    )
  }

  renderControl = () => {
    const props = {
      className: `${this.props.className}-control`,
      id: this.props.id,
      type: this.props.type,
      placeholder: this.props.placeholder,
      value: this.props.value == null ? '' : this.props.value,
      disabled: this.props.disabled,
      maxLength: this.props.maxLength,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur,
      onChange: this.handleChange,
      spellCheck: this.props.spellCheck,
      autoFocus: this.props.autoFocus,
    }

    return this.props.format ? (
      <Cleave {...props} options={this.props.format} />
    ) : (
      <input {...props} />
    )
  }

  renderErrorMaybe = () => {
    if (!this.props.error) return

    return <FormErrorAlert>{this.props.error}</FormErrorAlert>
  }

  renderSuccessMaybe = () => {
    if (!this.props.success) return

    return <FormSuccessAlert>{this.props.success}</FormSuccessAlert>
  }

  handleChange = (event: SyntheticInputEvent<>) => {
    this.props.onChange(event.target.value)
  }

  get classNameModifier(): string {
    const className = this.props.className

    return [
      this.props.error ? `${className}--error` : '',
      this.props.success ? `${className}--success` : '',
      this.props.appendAddOn ? `${className}--withAppendAddOn` : '',
      this.props.appearance === 'white' ? `${className}--white` : '',
    ].join(' ')
  }
}
